import axios from 'axios';
export const axiosClient = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_API_URL : process.env.REACT_APP_DEVELOPMENT_API_URL,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
    },
    timeout: 10000,
    withCredentials: true,
});
